import { render, staticRenderFns } from "./referral-qr-code.vue?vue&type=template&id=de139982&scoped=true&"
import script from "./referral-qr-code.vue?vue&type=script&lang=js&"
export * from "./referral-qr-code.vue?vue&type=script&lang=js&"
import style0 from "./referral-qr-code.vue?vue&type=style&index=0&id=de139982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de139982",
  null
  
)

export default component.exports